import { Input } from '@/components/ui/Input';
import { Select } from '@/components/ui/Select';
import { FileUpload } from '@/components/ui/FileUpload';
import { COMMON_TIMEZONE_OPTIONS } from '@/lib/timezone';
import type { DatasetFormData } from '@/components/datasets/useDatasetForm';
import styles from './DatasetForm.module.css';

interface DatasetFormProps {
  formData: DatasetFormData;
  error: string | null;
  setField: (field: 'displayName' | 'instrument' | 'sourceTimezone', value: string) => void;
  setFile: (field: 'candlesFile' | 'newsFile', file: File | null) => void;
  isEdit: boolean;
}

export function DatasetForm({ formData, error, setField, setFile, isEdit }: DatasetFormProps) {
  const filesProvided = !!(formData.candlesFile && formData.newsFile);

  return (
    <div className={styles.form}>
      <div className={styles.metadataFields}>
        <Input
          label="Name"
          value={formData.displayName}
          onChange={(e) => setField('displayName', e.target.value)}
          placeholder="XAU Apr-May"
          required={!isEdit}
        />
        <Input
          label="Instrument"
          value={formData.instrument}
          onChange={(e) => setField('instrument', e.target.value)}
          required
        />
        <Select
          label="Candle Timezone"
          value={formData.sourceTimezone}
          onChange={(e) => setField('sourceTimezone', e.target.value)}
          options={COMMON_TIMEZONE_OPTIONS}
          required
        />
      </div>

      <div className={styles.fileFields}>
        <FileUpload
          label="1m Candles CSV"
          accept=".csv,text/csv"
          value={formData.candlesFile}
          onChange={(f) => setFile('candlesFile', f)}
          required={!isEdit}
        />
        <FileUpload
          label="News Events CSV"
          accept=".csv,text/csv"
          value={formData.newsFile}
          onChange={(f) => setFile('newsFile', f)}
          required={!isEdit}
        />
      </div>

      {isEdit && filesProvided && (
        <p className="statusText statusTextInfo m-0">
          Both CSV files selected — saving will replace the dataset data.
        </p>
      )}
      {isEdit && !filesProvided && (
        <p className="statusText statusTextMuted m-0">
          Leave both file fields empty to update metadata only.
        </p>
      )}

      {error && (
        <p className="statusText statusTextDanger m-0" role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
